/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_ViewInputs */

const cs_ebr_diff_view = /** @type {(inputs: Ebr_Diff_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazení rozdílu`)
};

const en_ebr_diff_view = /** @type {(inputs: Ebr_Diff_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diff view`)
};

/**
* | output |
* | --- |
* | "Diff view" |
*
* @param {Ebr_Diff_ViewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_view = /** @type {((inputs?: Ebr_Diff_ViewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_ViewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_view(inputs)
	return cs_ebr_diff_view(inputs)
});